import { Link } from 'react-router-dom';
import Logo from '../components/Logo';

export default function Imprint() {
  return (
    <div style={{ minHeight: '100vh', backgroundColor: 'var(--bg-secondary)' }}>
      {/* Header */}
      <header style={{
        background: 'linear-gradient(135deg, var(--primary) 0%, var(--primary-dark) 100%)',
        color: 'white',
        padding: '2rem 1.5rem',
        textAlign: 'center'
      }}>
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{ marginBottom: '1rem' }}>
            <Logo variant="light" size="medium" />
          </div>
          <h1 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '0.5rem' }}>
            Impressum
          </h1>
          <Link to="/" style={{ color: 'white', opacity: 0.9, textDecoration: 'none', fontSize: '0.95rem' }}>
            ← Zurück zur Startseite
          </Link>
        </div>
      </header>

      {/* Content */}
      <main style={{ padding: '3rem 1.5rem' }}>
        <div className="container" style={{ maxWidth: '900px', margin: '0 auto' }}>
          <div style={{ backgroundColor: 'var(--bg-primary)', borderRadius: '0.5rem', padding: '2rem', boxShadow: 'var(--shadow-md)' }}>
            <p style={{ fontSize: '0.875rem', color: 'var(--gray-500)', marginBottom: '2rem' }}>
              Angaben gemäß § 5 TMG
            </p>

            <section style={{ marginBottom: '2rem' }}>
              <h2 style={{ fontSize: '1.5rem', fontWeight: '600', color: 'var(--gray-900)', marginBottom: '1rem' }}>
                Betreiber
              </h2>
              <p style={{ lineHeight: '1.8', color: 'var(--gray-700)' }}>
                Marcel Stelzner<br />
                c/o Online-Impressum.de 6020<br />
                Europaring 90<br />
                53757 Sankt Augustin<br />
                Deutschland
              </p>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2 style={{ fontSize: '1.5rem', fontWeight: '600', color: 'var(--gray-900)', marginBottom: '1rem' }}>
                Kontakt
              </h2>
              <p style={{ lineHeight: '1.8', color: 'var(--gray-700)' }}>
                E-Mail: post@meinelisten.app<br />
                Website: <a href="https://meinelisten.app" style={{ color: 'var(--primary)', textDecoration: 'none' }}>https://meinelisten.app</a>
              </p>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2 style={{ fontSize: '1.5rem', fontWeight: '600', color: 'var(--gray-900)', marginBottom: '1rem' }}>
                Verantwortlich für den Inhalt
              </h2>
              <p style={{ lineHeight: '1.8', color: 'var(--gray-700)' }}>
                Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:<br />
                Marcel Stelzner
              </p>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2 style={{ fontSize: '1.5rem', fontWeight: '600', color: 'var(--gray-900)', marginBottom: '1rem' }}>
                Haftungsausschluss
              </h2>
              
              <h3 style={{ fontSize: '1.25rem', fontWeight: '600', color: 'var(--gray-900)', marginBottom: '0.75rem', marginTop: '1.5rem' }}>
                Haftung für Inhalte
              </h3>
              <p style={{ lineHeight: '1.8', color: 'var(--gray-700)', marginBottom: '1rem' }}>
                Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, 
                Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. 
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten 
                nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als 
                Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde 
                Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige 
                Tätigkeit hinweisen.
              </p>

              <h3 style={{ fontSize: '1.25rem', fontWeight: '600', color: 'var(--gray-900)', marginBottom: '0.75rem', marginTop: '1.5rem' }}>
                Haftung für Links
              </h3>
              <p style={{ lineHeight: '1.8', color: 'var(--gray-700)', marginBottom: '1rem' }}>
                Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen 
                Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. 
                Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der 
                Seiten verantwortlich.
              </p>

              <h3 style={{ fontSize: '1.25rem', fontWeight: '600', color: 'var(--gray-900)', marginBottom: '0.75rem', marginTop: '1.5rem' }}>
                Urheberrecht
              </h3>
              <p style={{ lineHeight: '1.8', color: 'var(--gray-700)' }}>
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen 
                dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art 
                der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen 
                Zustimmung des jeweiligen Autors bzw. Erstellers.
              </p>
            </section>

            <section>
              <h2 style={{ fontSize: '1.5rem', fontWeight: '600', color: 'var(--gray-900)', marginBottom: '1rem' }}>
                Online-Streitbeilegung
              </h2>
              <p style={{ lineHeight: '1.8', color: 'var(--gray-700)' }}>
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
                <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--primary)', textDecoration: 'none', marginLeft: '0.25rem' }}>
                  https://ec.europa.eu/consumers/odr
                </a>
                <br />
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </section>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer style={{
        backgroundColor: 'var(--gray-800)',
        color: 'var(--gray-300)',
        padding: '2rem 1.5rem',
        textAlign: 'center'
      }}>
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <p style={{ marginBottom: '0.5rem' }}>
            © 2026 meinelisten.app - Einkaufslisten gemeinsam verwalten
          </p>
          <div style={{ display: 'flex', gap: '1.5rem', justifyContent: 'center', marginBottom: '0.5rem' }}>
            <Link 
              to="/datenschutz" 
              style={{ 
                color: 'var(--gray-300)', 
                textDecoration: 'none',
                fontSize: '0.875rem'
              }}
            >
              Datenschutz
            </Link>
            <Link 
              to="/impressum" 
              style={{ 
                color: 'var(--primary)', 
                textDecoration: 'none',
                fontSize: '0.875rem',
                fontWeight: '600'
              }}
            >
              Impressum
            </Link>
          </div>
          <p style={{ fontSize: '0.875rem', opacity: 0.8 }}>
            Made with ❤️ in Germany
          </p>
        </div>
      </footer>
    </div>
  );
}
